import type { IReqPage, IResPage } from '@/types/apis/base'
import type { IResCreationTaskItem } from '@/types/apis/task'
import type {
  IReqAddHistory,
  IReqCollect,
  IReqLike,
  IReqTheaterCat,
  IReqTheaterPayload,
  IResCreationCategory,
  IResCollectListItem,
  IResHistoryListItem,
  IResLikeListItem,
  IResRecommendedTheaterItem,
  IResTheaterInfo,
  IResTheaterItem,
} from '@/types/apis/theater'
import { post, get } from '@/utils/http'

// 获取剧本分类
export const apiGetTheaterCats = () =>
  post<IReqTheaterCat[]>('/UserClip/AILionDrama/GetAllCategories?categoryType=ScriptType')

// 获取创作分类
export const apiGetEnabledAITextToVideoCategories = () =>
  get<IResCreationCategory[]>('/UserClip/AILionDrama/GetEnabledAITextToVideoCategories')

// 根据筛选条件获取短剧列表
export const apiGetTheaterByPayload = (data: IReqTheaterPayload) => {
  return post<IResPage<IResTheaterItem>>('/UserClip/AILionDrama/SearchScripts', data)
}

// 获取短剧详情
export const apiGetTheaterInfo = (payload: { scriptId: number } | { scriptIdKey: string }) => {
  return post<IResTheaterInfo>(`/UserClip/AILionDrama/GetScriptDetail`, void 0, {
    params: payload,
  })
}

// 推荐剧本（首页推荐流）
// transform: false — 大列表数据由 data-adapter 层处理 i18n，跳过 HTTP 层递归深拷贝
export const apiGetRecommendedFeed = (payload: { PageSize: number; LastEpisodeId: number | null }) => {
  return post<IResRecommendedTheaterItem[]>('/UserClip/AILionDrama/GetRecommendedFeed', payload, { transform: false })
}

// 推荐创作(首页推荐流)
// transform: false — 同上
export const apiGetRecommendCreations = (payload: {
  PageSize: number
  LastEpisodeId: number | null
  VideoCategoryId: number | null
}) => {
  return post<IResCreationTaskItem[]>('/UserClip/AILionDrama/GetRecommendedCreationFeed', payload, { transform: false })
}

// 点赞
export const apiLike = (payload: IReqLike) => post<IResLikeListItem>('/UserClip/AILionDrama/LikeEpisode', payload)

// 取消点赞
export const apiUnlike = (payload: IReqLike) => post<IResLikeListItem>('/UserClip/AILionDrama/UnlikeEpisode', payload)

// 点赞列表
export const apiLikeList = (payload: IReqPage) =>
  post<IResPage<IResLikeListItem>>('/UserClip/AILionDrama/GetLikes', payload)

// 收藏
export const apiCollect = (payload: IReqCollect) =>
  post<IResCollectListItem>('/UserClip/AILionDrama/CollectEpisode', payload)

// 取消收藏
export const apiUncollect = (payload: IReqCollect) =>
  post<IResCollectListItem>('/UserClip/AILionDrama/UncollectEpisode', payload)

// 收藏列表
export const apiCollectList = (payload: IReqPage) =>
  post<IResPage<IResCollectListItem>>('/UserClip/AILionDrama/GetCollections', payload)

// 添加浏览记录
export const apiAddHistory = (payload: IReqAddHistory) =>
  post<IResHistoryListItem>('/UserClip/AILionDrama/UpdateWatchHistory', payload)

// 批量添加浏览记录
export const apiAddHistoryBatch = (payload: IReqAddHistory[]) =>
  post('/UserClip/AILionDrama/BatchUpdateWatchHistory', payload)

// 浏览历史列表
export const apiHistoryList = (payload: IReqPage) =>
  post<IResPage<IResHistoryListItem>>('/UserClip/AILionDrama/GetLastWatchPerScriptList', payload)
